import { useEffect, useState } from "react";
import { useSeo } from "@/lib/seo";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function PaymentReturn({ cancelled }) {
  useSeo({ title: "Payment", noindex: true });
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [msg, setMsg] = useState(cancelled ? "Payment cancelled." : "Confirming your payment…");
  const sid = params.get("session_id");

  useEffect(() => {
    if (cancelled || !sid) return;
    let tries = 0;
    const poll = async () => {
      try {
        const s = await api.paymentStatus(sid);
        if (s.payment_status === "paid" && s.status_token) {
          nav(`/status/${s.status_token}`);
          return;
        }
      } catch (e) {}
      if (++tries < 12) setTimeout(poll, 2000);
      else setMsg("Payment is taking a moment. Check your email for the status link.");
    };
    poll();
  }, [sid, cancelled, nav]);

  return (
    <div className="app-main"><div className="wrap" style={{ maxWidth: 640 }}>
      <h1 style={{ fontSize: "clamp(28px,6vw,40px)" }} data-testid="payment-return-title">{cancelled ? "Checkout cancelled" : "Thanks — payment received"}</h1>
      <p className="lede" data-testid="payment-return-msg">{msg}</p>
      {cancelled && <a className="btn" href="/#packages">Back to packages</a>}
    </div></div>
  );
}
